/* Saffron Distribution — comportamenti minimi: varianti, quantità, miniature. */
(function () {
  'use strict';

  function money(cents, format) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return format ? format.replace(/\{\{\s*amount[^}]*\}\}/, v) : v + ' €';
  }

  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = root.querySelector('[data-product-form]');
    var idInput = form && form.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var unitEl = root.querySelector('[data-unit-price]');
    var button = root.querySelector('[data-add]');
    var moneyFormat = root.getAttribute('data-money-format');
    var soldOutText = root.getAttribute('data-sold-out') || 'Esaurito';
    var addText = root.getAttribute('data-add-text') || 'Aggiungi al carrello';

    function selected() {
      var vals = [];
      root.querySelectorAll('[data-option-input]:checked').forEach(function (i) { vals[+i.getAttribute('data-position') - 1] = i.value; });
      root.querySelectorAll('select[data-option-select]').forEach(function (s) { vals[+s.getAttribute('data-position') - 1] = s.value; });
      return vals;
    }

    function update() {
      var vals = selected();
      var variant = product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === vals[i]; });
      })[0];
      if (!variant) {
        if (button) { button.disabled = true; button.textContent = soldOutText; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        priceEl.textContent = '';
        if (variant.compare_at_price > variant.price) {
          var old = document.createElement('s');
          old.textContent = money(variant.compare_at_price, moneyFormat);
          priceEl.appendChild(old);
        }
        priceEl.appendChild(document.createTextNode(money(variant.price, moneyFormat)));
      }
      if (unitEl) {
        var g = variant.weight_grams || 0;
        unitEl.textContent = g > 0 ? money(Math.round(variant.price / g), moneyFormat) + ' al grammo' : '';
      }
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? addText : soldOutText;
      }
      if (variant.featured_image) {
        var main = root.querySelector('[data-main-image]');
        if (main) { main.src = variant.featured_image; }
      }
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', variant.id);
        history.replaceState({}, '', u.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input], select[data-option-select]')) update();
    });

    root.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        var main = root.querySelector('[data-main-image]');
        if (main) { main.src = b.getAttribute('data-src'); main.alt = b.getAttribute('data-alt') || ''; }
        root.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });
  }

  function initQty(scope) {
    scope.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10);
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }


  function initSearch() {
    document.querySelectorAll('[data-search]').forEach(initSearchForm);
  }

  function initSearchForm(form) {
    var input = form.querySelector('[data-search-input]');
    var box = form.querySelector('[data-search-results]');
    var timer = null;
    var last = '';

    function clear() { while (box.firstChild) box.removeChild(box.firstChild); }
    function close() { box.hidden = true; clear(); }

    function line(cls, text) {
      var el = document.createElement('div');
      el.className = cls;
      el.textContent = text;
      return el;
    }

    function render(products, q) {
      clear();
      if (!products.length) {
        box.appendChild(line('search__empty', 'Nessun risultato per "' + q + '"'));
      } else {
        products.forEach(function (p) {
          var a = document.createElement('a');
          a.className = 'search__hit';
          a.href = p.url;
          var img = document.createElement('img');
          img.alt = '';
          img.width = 52; img.height = 52;
          img.src = (p.image || (p.featured_image && p.featured_image.url) || '');
          if (!img.src) img.style.visibility = 'hidden';
          var t = document.createElement('span');
          t.className = 'search__hit-title';
          t.textContent = p.title;
          var pr = document.createElement('span');
          pr.className = 'search__hit-price';
          pr.textContent = p.price ? money(Math.round(parseFloat(p.price) * 100)) : '';
          a.appendChild(img); a.appendChild(t); a.appendChild(pr);
          box.appendChild(a);
        });
        var all = document.createElement('a');
        all.className = 'search__all';
        all.href = form.getAttribute('action') + '?type=product&q=' + encodeURIComponent(q);
        all.textContent = 'Vedi tutti i risultati';
        box.appendChild(all);
      }
      box.hidden = false;
    }

    function run(q) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (input.value.trim() !== q) return;
          var list = (d.resources && d.resources.results && d.resources.results.products) || [];
          render(list, q);
        })
        .catch(function () { close(); });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { last = ''; close(); return; }
      if (q === last) return;
      last = q;
      timer = setTimeout(function () { run(q); }, 200);
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSearch();
    document.querySelectorAll('[data-product]').forEach(initProduct);
    initQty(document);
  });
})();
